
import { Box, Divider, Card, CardActions, Switch, CardMedia, Stack, FormControl, RadioGroup, Radio, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, Tabs, useTheme, AppBar, FormGroup, FormControlLabel, Checkbox, Button, Toolbar, Menu, MenuItem, TableContainer, Table, TableHead, TableCell, TableRow, TableBody } from "@mui/material";
import { styled } from '@mui/material/styles';


import  { useState, useEffect, useRef } from "react";



import CallAlertBar from "../../../Layout/Alertbar";



import 'dayjs/plugin/customParseFormat';



// icon

import Close from '@mui/icons-material/Close';
import useSalaryStructureDetailByID from "../../../hooks/useSalaryStructureDetailById";

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import EditIcon from '@mui/icons-material/Edit';
import useSalaryCompensationCRUD from "../../../hooks/useSalaryCompensation";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import useGetEmployeeCompensationDetById from "../../../hooks/useGetSalaryCompensationDetailByEmployeeID";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { tokens } from "../../../theme/theme";


const EmployeeCompensation = ({ handlecallback, editEmployeeID, employee_code, initialData = null }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    // Parent Roll  Alert Values
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [selectedButton, setSelectedButton] = useState(null);


    // Display Message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };


    const callback = () => { handlecallback(); }
    const { employeeCompensation, activeCompensation, setEmployeeCompensation, setActiveCompensation, EmployeeCompensationDetail } = useGetEmployeeCompensationDetById(editEmployeeID);
    const { componentsDetail, componentsList, setComponentsDetail, setComponentsList, LoadSalaryStructure, LoadSalaryStructureDetailWithoutID } = useSalaryStructureDetailByID();
    const { processIndent } = useSalaryCompensationCRUD(CallMessage);

    //-- get Project Number
    const [employeeCode, setEmployeeCode] = useState([]);
    const [isProjectNumberLoaded, setIsProjectNumberLoaded] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    // Project Lead

    const [employeeExitID, setEmployeeExitID] = useState(0);

    // employee status
    const [open, setOpen] = useState(false);
    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');
    const [employees, setEmployees] = useState([]);
    const [salaryStructures, setSalaryStructures] = useState([]);
    const [selectedSalaryStructureId, setSelectedSalaryStructureId] = useState(0);
    const [salaryID, setSalaryId] = useState(0);

    const [viewCompensation, setViewCompensation] = useState(false);

    const CustomTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
    ))({
        [`& .MuiTooltip-tooltip`]: {
            backgroundColor: colors.blueAccent[500],
            color: 'white',
            fontSize: '14px',
            borderRadius: '10px',
            padding: '10px',

        },
        [`& .MuiTooltip-arrow`]: {
            color: colors.blueAccent[500],
        },
    });


    const [formData, setFormData] = useState({
        id_salary: '',
        id_employee: editEmployeeID,
        id_salary_structure: '',
        basic_pay: '',
        special_allowance: '',
        conveyance_allowance: '',
        medical_allowance: '',
        performance_incentives: '',
        graduity_eligible: false,
        effective_date: new Date().toISOString().slice(0, 10),
        status: true
    });


    const Addnew = () => {

        setSalaryId(0);

        setFormData(prev => ({
            ...prev,
            id_salary: '',
            id_employee: editEmployeeID,
            id_salary_structure: '',
            basic_pay: '',
            special_allowance: '',
            conveyance_allowance: '',
            medical_allowance: '',
            performance_incentives: '',
            graduity_eligible: false,
            effective_date: new Date().toISOString().slice(0, 10),
            status: true

        }));
    }


    const handleCallEdit = (value) => {
     

        const active = employeeCompensation.find((item) => item.id_salary_structure === value);

        setSalaryId(active.id_salary);

        // Update formData fields (assuming you're using setFormData to update state)
        setFormData(prev => ({
            ...prev,
            id_salary: active.id_salary || 0,
            id_salary_structure: active.id_salary_structure || 0,
            basic_pay: active.basic_pay || 0,
            special_allowance: active.special_allowance || 0,
            conveyance_allowance: active.conveyance_allowance || 0,
            medical_allowance: active.medical_allowance || 0,
            performance_incentives: active.performance_incentives || 0,
            graduity_eligible: active.graduity_eligible === '0' ? false : true,
            effective_date: active.effective_date
                ? formatDate(active.effective_date)
                : formatDate(new Date()),
            status: active.status === '0' ? false : true

        }));
    };

    // load Project Number

    useEffect(() => {
        if (!isProjectNumberLoaded) {
            if (editEmployeeID === 0) {

                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_modeid: 0,
                }

                callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => {
                        if (data?.length > 0) { setEmployeeCode(data[0].po_number); }
                    })
                    .catch(error => { CallMessage('error', error.message, 'Error'); });
            }
            else {
                const para = {
                    p_companyid: localStorage.getItem('companyid'),
                    p_modeid: 0,
                }

                callApi(API_ENDPOINTS.HR_GET_EMPLOYEE_DETAILS, 'POST', { 'Content-Type': 'application/json' }, para)
                    .then(data => {
                        if (Array.isArray(data) && data.length > 0) {
                            setEmployees(data);

                            // Check if the editEmployeeID exists in the new employee list
                            const employeeExists = data.some(emp => emp.id === editEmployeeID);

                            if (employeeExists) {
                                setFormData(prev => ({
                                    ...prev,
                                    id_employee: editEmployeeID
                                }));
                            } else {
                                // Optionally reset or choose default if ID is invalid
                                setFormData(prev => ({
                                    ...prev,
                                    id_employee: data[0].id  // fallback to first employee
                                }));
                            }
                        }

                    })
                    .catch(error => { CallMessage('error', error.message, 'Error'); });
            }
        }
    }, [isProjectNumberLoaded]);


    useEffect(() => {
        if (!isDataLoaded) {
            const para = { p_companyid: localStorage.getItem('companyid'), }
            callApi(API_ENDPOINTS.SALARY_STRUCTURE_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) { setSalaryStructures(data); }
                })
                .catch(error => { alert(error.message); });
        }
    }, [isDataLoaded]);


    // get salary structure components details
    useEffect(() => {
        const loadSalaryStructureDetail = async () => {
            if (selectedSalaryStructureId !== 0 && selectedSalaryStructureId !== '') {
                if (componentsDetail.length === 0) {
                    await LoadSalaryStructure(selectedSalaryStructureId);
                }
            }
        }
        loadSalaryStructureDetail();
    }, [selectedSalaryStructureId])


    useEffect(() => {
        if (componentsDetail.length > 0) {

            // comman data format
            const parseData = (data) => typeof data === 'string' ? JSON.parse(data) : data;

            // Handle Raw Material Rows
            const productData = parseData(componentsDetail);
            setComponentsList(Array.isArray(productData) ? productData : []);


            // Convert array to object for easy lookup by component_name
            const componentMap = {};
            productData.forEach(comp => {
                componentMap[comp.component_name] = comp.value;
            });

            // Update formData fields (assuming you're using setFormData to update state)
            setFormData(prev => ({
                ...prev,
                basic_pay: componentMap["BasicPay"] || 0,
                special_allowance: componentMap["Special Allowance"] || 0,
                conveyance_allowance: componentMap["Conveyance Allowance"] || 0,
                medical_allowance: componentMap["Medical Allowance"] || 0,
                performance_incentives: componentMap["Performance Incentives"] || 0
            }));


        }
    }, [componentsDetail])



    // new changes are done below 
    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        }
    }, [initialData]);

    const handleChange = (field) => (event) => {
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        if (formData.id_employee && formData.id_salary_structure) {
            onSave(formData);
        } else {
            alert("Please select an employee and salary structure.");
        }
    };


    // on save function
    const onSave = (data) => {
        let mode = salaryID ? 1 : 0;
        // inputs
        const payload = {
            p_id_salary: salaryID,
            p_mode: mode,
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_user: localStorage.getItem('userID'),
            p_employee_compensation: Array.isArray(data) ? data : [data],

        }
        processIndent(mode, salaryID, payload);
        EmployeeCompensationDetail(editEmployeeID);

    }


    const viewSalaryCompensation = (mode) => {
        if (mode === 0) { setViewCompensation(false); } else { setViewCompensation(true); }
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // load employee wise salary structure component list
    useEffect(() => {
        if (editEmployeeID !== 0 && employeeCompensation) {

            if (employeeCompensation && employeeCompensation.length > 0) {

                const active = employeeCompensation.find((item) => item.status === "1");

                setSalaryId(active.id_salary);

                // Update formData fields (assuming you're using setFormData to update state)
                setFormData(prev => ({
                    ...prev,
                    id_salary: active.id_salary || 0,
                    id_salary_structure: active.id_salary_structure || 0,
                    basic_pay: active.basic_pay || 0,
                    special_allowance: active.special_allowance || 0,
                    conveyance_allowance: active.conveyance_allowance || 0,
                    medical_allowance: active.medical_allowance || 0,
                    performance_incentives: active.performance_incentives || 0,
                    graduity_eligible: active.graduity_eligible === '0' ? false : true,
                    effective_date: active.effective_date
                        ? formatDate(active.effective_date)
                        : formatDate(new Date()),
                    status: active.status === '0' ? false : true

                }));
            }
        }
    }, [employeeCompensation], [activeCompensation], [setEmployeeCompensation]);



    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = employeeCompensation.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };
    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);


    };



    const filteredData = employeeCompensation.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    return (<>

        <Box>

            <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                {/* Left-aligned: Edit Employee */}
                <Grid item>
                    <Typography variant="h6" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                        {salaryID ? "Edit" : "Create"} Employee Compensation
                    </Typography>
                </Grid>

                {/* Right-aligned: Buttons */}
                <Grid item>
                    <Grid container alignItems="center">
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        {/* Save */}

                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton
                                    onClick={handleSubmit}
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                    type="submit"
                                >
                                    {salaryID === 0 ? (
                                        <SaveAltIcon style={{ fontSize: 18, color: selectedButton === 'save' ? 'yellow' : '#009688' }} />
                                    ) : (
                                        <EditIcon style={{ fontSize: 18, color: selectedButton === 'save' ? 'yellow' : '#009688' }} />
                                    )}
                                    <Typography variant="body2" sx={{ ml: 1 }}>  {salaryID !== 0 ? 'Edit' : 'Save'}</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton
                                    onClick={() => { viewSalaryCompensation(1) }}
                                    sx={{ display: 'flex', alignItems: 'center' }}
                                    type="submit"
                                >
                                    <VisibilityIcon style={{ fontSize: 18, color: selectedButton === 'save' ? 'yellow' : '#009688' }} />
                                    <Typography variant="body2" sx={{ ml: 1 }}> View Existing Salary Compensation </Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        <Grid item ml={1} mr={1}>
                            <Tooltip title="Add new orders">
                                <IconButton onClick={() => { Addnew() }} sx={{ display: 'flex', alignItems: 'center' }} type="submit" >
                                    <AddCircleIcon style={{ fontSize: 18, color: selectedButton === 'save' ? 'yellow' : '#009688' }} />
                                    <Typography variant="body2" sx={{ ml: 1 }}> Add New</Typography>
                                </IconButton>
                            </Tooltip>
                        </Grid>

                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        <IconButton onClick={callback}>
                            <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                        </IconButton>
                        <Divider orientation="vertical" flexItem

                        />
                    </Grid>
                </Grid>
            </Grid>

            <Divider />

            {/* Message box detail */}
            <CallAlertBar
                parentRollMsgOpen={msgOpen}
                setParentRollMsgOpen={setMsgOpen}
                parentRollSeverityvalue={severityValue}
                setParentRollSeverityvalue={setSeverityvalue}
                parentRollAlertTitleValue={alertTitleValue}
                setParentRollAlertTitleValue={setAlertTitleValue}
                parentRollMessageValue={messageValue}
                setParentRollMessageValue={setMessageValue} />

            <Box sx={{ p: 4, maxWidth: 600 }}>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            select
                            label="Employee"
                            fullWidth
                            value={formData.id_employee}
                            onChange={handleChange("id_employee")}
                            size="small"
                        >
                            {employees.map(emp => (
                                <MenuItem key={emp.id} value={emp.id}>
                                    {emp.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            select
                            label="Salary Structure"
                            fullWidth
                            value={formData.id_salary_structure}
                            onChange={(e) => {
                                const value = e.target.value;
                                handleChange("id_salary_structure")(e);
                                setSelectedSalaryStructureId(value);
                            }}
                            size="small"
                        >
                            {salaryStructures.map(str => (
                                <MenuItem key={str.id_salary_structure} value={str.id_salary_structure}>
                                    {str.salary_structure_name}
                                </MenuItem>
                            ))}
                        </TextField>

                    </Grid>

                    {[
                        { label: "Basic Pay", field: "basic_pay" },
                        { label: "Special Allowance", field: "special_allowance" },
                        { label: "Conveyance Allowance", field: "conveyance_allowance" },
                        { label: "Medical Allowance", field: "medical_allowance" },
                        { label: "Performance Incentives", field: "performance_incentives" }
                    ].map(item => (
                        <Grid item xs={6} key={item.field}>
                            <TextField
                                label={item.label}
                                fullWidth
                                size="small"
                                type="number"
                                value={formData[item.field]}
                                onChange={handleChange(item.field)}
                            />
                        </Grid>
                    ))}

                    <Grid item xs={6}>
                        <TextField
                            label="Effective Date"
                            type="date"
                            fullWidth
                            size="small"
                            value={formData.effective_date}
                            onChange={handleChange("effective_date")}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.graduity_eligible}
                                    color="secondary"
                                    size="small"
                                    onChange={handleChange("graduity_eligible")}
                                />
                            }
                            label="Gratuity Eligible"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.status}
                                    color="secondary"
                                    size="small"
                                    onChange={handleChange("status")}
                                />
                            }
                            label="Active Status"

                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider />
            {viewCompensation && (<>
                <Box>
                    <Grid container justifyContent="space-between" alignItems="center" padding={0} >
                        {/* Left-aligned: Edit Employee */}

                        <Grid item>
                            <Typography variant="h6" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>
                                Existing Salary Compensation List
                            </Typography>
                        </Grid>
                        {/* Right-aligned: Buttons */}
                        <Grid item>
                            <Grid container alignItems="center">

                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                                <IconButton onClick={() => { viewSalaryCompensation(0) }}>
                                    <VisibilityOffIcon style={{ fontSize: "14px", color: "#2196F3" }} />
                                </IconButton>
                                <Divider orientation="vertical" flexItem

                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Divider />
                <Box padding={1}>
                    <CustomTableContainer colors={colors}>
                        <TableContainer >
                            <Table size="small">
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>

                                        <TableCell>SALARY STRUCTURE CODE</TableCell>
                                        <TableCell>BASIC PAY</TableCell>
                                        <TableCell>SPECIAL ALLOWANCE</TableCell>
                                        <TableCell>CONVEYANCE </TableCell>
                                        <TableCell>MEDICAL</TableCell>
                                        <TableCell>INCENTIVES</TableCell>
                                        <TableCell>EFFECTIVE DATE</TableCell>
                                        <TableCell>GRATUITY ELLIGIBLE</TableCell>
                                        <TableCell>STATUS</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id}>


                                            <TableCell>
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleCallEdit(row.id_salary_structure)}
                                                >
                                                    {row.salary_structure_name}
                                                </span>
                                            </TableCell>
                                            <TableCell>{row.basic_pay}</TableCell>
                                            <TableCell>{row.special_allowance || ''}</TableCell>
                                            <TableCell>{row.conveyance_allowance || ''}</TableCell>
                                            <TableCell>{row.medical_allowance}</TableCell>
                                            <TableCell>{row.performance_incentives}</TableCell>
                                            <TableCell>{formatDate(row.effective_date)}</TableCell>
                                            <TableCell>{row.graduity_eligible === '0' ? 'De Active' : 'Active'}</TableCell>
                                            <TableCell>{row.status === '0' ? 'De Active' : 'Active'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CustomTableContainer>
                </Box>
            </>)}
        </Box>
    </>)
}
export default EmployeeCompensation;